import type { MouseEvent } from 'react';

import { Button } from '@com/_atoms/NewButton';
import { doctorCardTexts } from '@constant/ocs/doctor';
import useModal from '@hooks/useModal';
import DoctorOfficesListBottomsheet from '@containers/doctor-list/_components/doctor-office-list-bottomsheet';
import { useGetDoctorClinic } from '@api/in-person-booking/index.rq';
import { useGetDoctorProfile } from '@api/ocs/doctor/index.rq';
import useServiceBooking from '@hooks/useServiceBooking';

type InPersonBookingButtonProps = {
  isLoading?: boolean;
  doctorId: number;
  fullName: string;
  citiesLength: number;
  isJustNobatButton?: boolean;
  dataTestId?: string;
  onClick?: () => void;
};

const InPersonBookingButton = ({
  isLoading,
  doctorId,
  fullName,
  citiesLength,
  isJustNobatButton,
  dataTestId,
  onClick,
}: InPersonBookingButtonProps) => {
  const { addModal } = useModal();

  const { data: clinicData } = useGetDoctorClinic({
    doctorId: String(doctorId),
  });

  const { data: doctorProfileResponse } = useGetDoctorProfile(Number(doctorId));

  const { handleOpenServiceCalendar } = useServiceBooking({
    doctorId: Number(doctorId),
    profileId: doctorProfileResponse?.result?.profileId,
    doctorProfile: doctorProfileResponse?.result,
  });

  const handleOpeningPersonDoctorOfficeBottomsheet = () => {
    addModal({
      modal: DoctorOfficesListBottomsheet,
      props: { doctorId, doctorName: fullName },
    });
  };

  const handleInPersonVisitClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    if (onClick) {
      onClick();
      return;
    }
    if (citiesLength > 1) {
      handleOpeningPersonDoctorOfficeBottomsheet();
    } else {
      handleOpenServiceCalendar({ clinic: clinicData?.data?.[0] });
    }
  };

  return (
    <Button
      variant="secondary"
      size="medium"
      dataTestId={dataTestId}
      className="w-full !text-Label/Small"
      onClick={handleInPersonVisitClick}
      isLoading={isLoading}
    >
      {isJustNobatButton
        ? doctorCardTexts.bookingNobat
        : doctorCardTexts.onPersonVisit}
    </Button>
  );
};

export default InPersonBookingButton;
